import fb from '@/firebaseConfig';

/*

  STATE

 */

const state = {
  previewCards: {},
  allCards: {},
  allCardIds: [],
  journeyIds: [],
  deepeningIds: [],
  lighteningIds: [],
  isLoaded: false,
};


/*

  GETTERS

 */

const getters = {
};


/*

  ACTIONS

 */

const actions = {

  init({ dispatch, state, rootGetters }) {
    const isSignedIn = rootGetters['user/isSignedIn'];
    const { isLoaded } = state;

    dispatch('fetchPreviewCards');

    if (isSignedIn && !isLoaded) {
      dispatch('fetchCards');
    }
  },

  fetchCards({ commit, dispatch, rootGetters }) {
    const isPremiumUser = rootGetters['user/isPremiumUser'];
    let query;
    if (isPremiumUser) {
      query = fb.cardsCollection.orderBy('title');
    } else {
      query = fb.cardsCollection.where('type', '==', 'free').orderBy('title');
    }

    query.onSnapshot((snapshot) => {
      const allCards = {};
      const allCardIds = [];
      const journeyIds = [];
      const deepeningIds = [];
      const lighteningIds = [];

      snapshot.forEach((doc) => {
        const { id } = doc;
        const data = doc.data();
        const { category } = data;

        allCards[id] = data;
        allCardIds.push(id);

        if (category === 'journey') {
          journeyIds.push(id);
        } else if (category === 'deepening') {
          deepeningIds.push(id);
        } else if (category === 'lightening') {
          lighteningIds.push(id);
        }
      });

      commit('setCardsAndCategories', {
        allCards,
        allCardIds,
        journeyIds,
        deepeningIds,
        lighteningIds,
      });

      dispatch('dailyCards/init', null, { root: true });
    },
    (error) => {
      console.error('Error fetching cards: ', error);
    });
  },

  fetchPreviewCards({ commit }) {
    fb.cardsCollection.where('isPreviewCard', '==', true).get()
      .then((snapshot) => {
        const previewCards = {};
        snapshot.forEach((doc) => {
          const { id } = doc;
          const data = doc.data();
          previewCards[id] = data;
        });
        commit('setPreviewCards', previewCards);
      })
      .catch((error) => {
        console.log('Error fetching preview cards: ', error);
      });
  },

  // unsubscribeToCardSnapshots() {
  //   const unsubscribe = fb.cardsCollection.onSnapshot(function () {});
  //   unsubscribe();
  // },

  // getRandomCard({ state, getters }, category) {
  //   const set = state[`${category}Ids`] || state.currentSet;
  //   const randomIndex = Math.floor(Math.random() * set.length);
  //   const randomId = set[randomIndex];
  //   return {
  //     cardId: randomId,
  //     index: randomIndex,
  //     set,
  //   };
  // },

};


/*

  MUTATIONS

 */

const mutations = {
  setCardsAndCategories(state, data) {
    const {
      allCards,
      allCardIds,
      journeyIds,
      deepeningIds,
      lighteningIds,
    } = data;

    state.allCards = allCards;
    state.allCardIds = allCardIds;
    state.journeyIds = journeyIds;
    state.deepeningIds = deepeningIds;
    state.lighteningIds = lighteningIds;
    state.isLoaded = true;
  },

  setPreviewCards(state, previewCards) {
    state.previewCards = previewCards;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
